import { Moment } from 'moment';
import moment from 'moment-timezone';

type Props = {
  dateStr?: string | null | Moment;
  isLocalTime?: boolean;
  formatStr?: string;
  isShippingDate?: boolean;
};
export const SHIPPING_DATE_FORMAT = 'MMM D, YYYY';
export const ORDER_DATE_FORMAT = 'MMMM DD, YYYY';
export const ADJUSTMENT_DATE_FORMAT = 'MM-DD, YYYY';
export const DEFAULT_DATE_FORMAT = 'MM/DD/YYYY';
export const ORDER_HISTORY_DATE_FORMAT = 'MM/DD/YYYY HH:mm';
export const DATETIME_24H_FORMAT = 'MM/DD/YYYY HH:mm';
export const NOTE_DATE_FORMAT = 'h:mm A';
export const SHIPPING_DATE_FORMAT_LOCAL = 'YYYY-MM-DDTHH:mm:ss.SSS';
export const RFQ_SHIPPING_DATE_FORMAT_LOCAL = 'YYYY-MM-DD';

export const getFormatDate = ({ dateStr, formatStr, isLocalTime }: Props) => {
  let finalDateStr = dateStr;
  if (isLocalTime) {
    finalDateStr = (dateStr as string).replace('Z', '');
  }

  return finalDateStr
    ? moment(finalDateStr).format(formatStr || DEFAULT_DATE_FORMAT)
    : '';
};
export const RevxDate = ({
  dateStr,
  formatStr,
  isLocalTime,
  isShippingDate,
}: Props) => {
  let finalDateStr = dateStr;
  if (isLocalTime) {
    finalDateStr = ((dateStr as string) || '').replace('Z', '');
  }
  if (isShippingDate) {
    formatStr = SHIPPING_DATE_FORMAT;
  }
  return (
    <>
      {finalDateStr
        ? moment(finalDateStr).format(formatStr || DEFAULT_DATE_FORMAT)
        : null}
    </>
  );
};
